/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assetlibrarypickertitle3Inputs */

const en_assetlibrarypickertitle3 = /** @type {(inputs: Assetlibrarypickertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose from your library`)
};

const de_assetlibrarypickertitle3 = /** @type {(inputs: Assetlibrarypickertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus deiner Mediathek wählen`)
};

/**
* | output |
* | --- |
* | "Choose from your library" |
*
* @param {Assetlibrarypickertitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const assetlibrarypickertitle3 = /** @type {((inputs?: Assetlibrarypickertitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assetlibrarypickertitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assetlibrarypickertitle3(inputs)
	return de_assetlibrarypickertitle3(inputs)
});
export { assetlibrarypickertitle3 as "assetLibraryPickerTitle" }